<template>
	<v-dialog persistent v-model="dialog" width="500" v-if="showCookiesBar">
		<template v-slot:activator="{ on, attrs }">
			<v-banner single-line transition="slide-y-transition" v-bind="attrs" v-on="on" v-model="model">
				<v-icon slot="icon" color="secondary">far fa-info-circle</v-icon>

				<span>{{ $t('pui9.cookiebar.message') }}</span>

				<template v-slot:actions>
					<v-menu v-if="isMobile">
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon v-bind="attrs" v-on="on">
								<v-icon>far fa-ellipsis-v</v-icon>
							</v-btn>
						</template>

						<v-list dense>
							<v-list-item>
								<v-list-item-title @click="accept">{{ $t('pui9.cookiebar.accept') }}</v-list-item-title>
							</v-list-item>
							<v-list-item>
								<v-list-item-title @click="dialog = true">{{ $t('pui9.cookiebar.policy.title') }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
					<v-btn v-if="!isMobile" color="secondary" text @click="accept">{{ $t('pui9.cookiebar.accept') }}</v-btn>
					<v-btn v-if="!isMobile" color="primary" text @click="dialog = true">{{ $t('pui9.cookiebar.policy.title') }}</v-btn>
				</template>
			</v-banner>
		</template>

		<v-card>
			<v-card-title class="text-h5">{{ $t('pui9.cookiebar.policy.title') }}</v-card-title>

			<v-card-text><div v-html="policyMessage" /></v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" text @click="dialog = false">{{ $t('pui9.cookiebar.accept') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'PuiCookiesBar',
	data() {
		return {
			isMobile: this.$store.getters.isMobile,
			showCookiesBar: this.$store.getters.showCookiesBar,
			dialog: false,
			model: false,
			policyMessage: this.$t('pui9.cookiebar.policy.message')
		};
	},
	created() {
		const gdpr = window.localStorage.getItem('pui9_gdpr');
		this.model = !gdpr || gdpr === "false";
	},
	methods: {
		accept() {
			this.model = false;
			window.localStorage.setItem('pui9_gdpr', true);
		}
	}
};
</script>
